/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "扩展样式(Extending Styles)"
    }), "\n", _jsx(_components.p, {
      children: "¥Extending Styles"
    }), "\n", _jsx(_components.p, {
      children: "你可能经常想要使用某个组件，但针对单个情况稍微更改一下。现在，你可以传入一个插值函数并根据某些属性更改它们，但是一次覆盖样式需要付出很大的努力。"
    }), "\n", _jsx(_components.p, {
      children: "¥Quite frequently you might want to use a component, but change it slightly for a single case. Now, you could pass in an interpolated function and change them based on some props, but that's quite a lot of effort for overriding the styles once."
    }), "\n", _jsxs(_components.p, {
      children: ["要轻松创建继承另一个组件样式的新组件，只需将其封装在 ", _jsx(_components.code, {
        children: "styled()"
      }), " 构造函数中即可。在这里，我们使用上一节中的按钮并创建一个特殊的按钮，并使用一些与颜色相关的样式对其进行扩展："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To easily make a new component that inherits the styling of another, just wrap it in the ", _jsx(_components.code, {
        children: "styled()"
      }), " constructor. Here we use the button from the last section and create a special one, extending it with some color-related styling:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// The Button from the last section without the interpolations\nconst Button = styled.button`\n  color: #BF4F74;\n  font-size: 1em;\n  margin: 1em;\n  padding: 0.25em 1em;\n  border: 2px solid #BF4F74;\n  border-radius: 3px;\n`;\n\n// A new component based on Button, but with some override styles\nconst TomatoButton = styled(Button)`\n  color: tomato;\n  border-color: tomato;\n`;\n\nrender(\n  <div>\n    <Button>Normal Button</Button>\n    <TomatoButton>Tomato Button</TomatoButton>\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["我们可以看到，新的 ", _jsx(_components.code, {
        children: "TomatoButton"
      }), " 仍然类似于 ", _jsx(_components.code, {
        children: "Button"
      }), "，但我们只添加了两条新规则。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We can see that the new ", _jsx(_components.code, {
        children: "TomatoButton"
      }), " still resembles ", _jsx(_components.code, {
        children: "Button"
      }), ", while we have only added two new rules."]
    }), "\n", _jsx(_components.p, {
      children: "在某些情况下，你可能想要更改样式组件渲染的标签或组件。例如，在构建导航栏时，这种情况很常见，其中混合了锚链接和按钮，但它们的样式应该相同。"
    }), "\n", _jsx(_components.p, {
      children: "¥In some cases you might want to change which tag or component a styled component renders. This is common when building a navigation bar for example, where there are a mix of anchor links and buttons but they should be styled identically."
    }), "\n", _jsxs(_components.p, {
      children: ["对于这种情况，我们有一个应急方案。你可以使用 ", _jsx(_components.a, {
        href: "/docs/api#as-polymorphic-prop",
        children: _jsx(_components.code, {
          children: "\"as\" polymorphic prop"
        })
      }), " 动态交换接收你编写的样式的元素："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For this situation, we have an escape hatch. You can use the ", _jsx(_components.a, {
        href: "/docs/api#as-polymorphic-prop",
        children: _jsx(_components.code, {
          children: "\"as\" polymorphic prop"
        })
      }), " to dynamically swap out the element that receives the styles you wrote:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Button = styled.button`\n  display: inline-block;\n  color: #BF4F74;\n  font-size: 1em;\n  margin: 1em;\n  padding: 0.25em 1em;\n  border: 2px solid #BF4F74;\n  border-radius: 3px;\n  display: block;\n`;\n\nconst TomatoButton = styled(Button)`\n  color: tomato;\n  border-color: tomato;\n`;\n\nrender(\n  <div>\n    <Button>Normal Button</Button>\n    <Button as=\"a\" href=\"#\">Link with Button styles</Button>\n    <TomatoButton as=\"a\" href=\"#\">Link with Tomato Button styles</TomatoButton>\n  </div>\n);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "这也适用于自定义组件！"
    }), "\n", _jsx(_components.p, {
      children: "¥This works perfectly fine with custom components too!"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Button = styled.button`\n  display: inline-block;\n  color: #BF4F74;\n  font-size: 1em;\n  margin: 1em;\n  padding: 0.25em 1em;\n  border: 2px solid #BF4F74;\n  border-radius: 3px;\n  display: block;\n`;\n\nconst ReversedButton = props => <Button {...props} children={props.children.split('').reverse()} />\n\nrender(\n  <div>\n    <Button>Normal Button</Button>\n    <Button as={ReversedButton}>Custom Button with Normal Button styles</Button>\n  </div>\n);\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
